/**
 * 获取数据集列表
 * @param url
 * @returns {Promise<unknown>}
 */
export async function validateDpsService(url) {
    let dpsQuery = new GeoGlobe.Query.DPSQuery({url});
    return new Promise((resolve, reject) => {
        dpsQuery.getDataSetList(null,function (res) {//成功回调
            resolve(res)
        }, function (res) {//失败回调
            console.log(res)
            resolve(res)
        })
    })
}
/**
 * 获取字段
 * @param {String} Url
 * @param {String} DataSetId
 */
export async function describeDataSet(url, DataSetId) {
    let dpsQuery = new GeoGlobe.Query.DPSQuery({url});
    return new Promise((resolve, reject) => {
        dpsQuery.describeDataSet({
            dataSetId: DataSetId
        },function (res) {//成功回调
            resolve(res.fields)
        }, function (res) {//失败回调
            console.log(res)
            resolve(res)
        })
    })
}

/**
 * dps服务查询
 * @param {String} url
 * @param {Boolean} dataSetId
 * @param {String} rowFilter 通过>,<,=,like等过滤属性值 如：[{name: 'NAME', value: '%创新综合体%', type: 'like'}, {name: '空置面积', value: '10000', type: '>'}, {name: '空置面积', value: '12000', type: '<'}]
 * @param {String} colFilter 过滤字段，多个以','分割 如 'name,oid,type' 则只会显示这3个字段
 */
export async function queryDPS(url, dataSetId, rowFilter, colFilter) {
    let dpsQuery = new GeoGlobe.Query.DPSQuery({url});
    return new Promise((resolve, reject) => {
        dpsQuery.describeDataSet({
            dataSetId: dataSetId,
            rowFilter: rowFilter,
            colFilter: colFilter
        },function (res) {//成功回调
            resolve(res)
        }, function (res) {//失败回调
            console.log(res)
            resolve(res)
        })
    })
}
